<template>
  <a-modal
    v-model:visible="showModal"
    title="选择图标"
    @ok="handleOk"
    width="800px"
    :bodyStyle="{ padding: 0 }"
  >
    <div class="icon-select-container">
      <div class="search-bar">
        <a-input
          v-model:value="searchValue"
          placeholder="搜索图标"
          allowClear
        />
      </div>

      <div class="icon-content">
        <div class="icon-groups">
          <div
            v-for="group in filterIconData"
            :key="group.group"
            class="icon-group"
          >
            <div class="group-title">{{ group.group }}</div>
            <div class="icon-grid">
              <div
                v-for="icon in group.icons"
                :key="icon.name"
                class="icon-item"
                :class="{ 'icon-selected': value1?.value === icon.value }"
                @click="selectIcon(icon)"
              >
                <component
                  class="anticon"
                  :is="icon.value"
                />
                <div class="icon-name">{{ icon.name }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script lang="ts">
import { defineComponent, ref, computed, onUpdated } from 'vue';

export default defineComponent({
  name: 'SelectIconModal',
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => {},
    },
    icon_data: {
      type: Array as () => any[],
      default: () => [],
    },
  },
  emits: ['update:value', 'update:showModal'],
  setup(props, { emit }) {
    const showModal = ref(props.showModal);
    const searchValue = ref<string>('');
    const value1 = ref(props.value);

    const handleOk = () => {
      emit('update:value', value1.value);
      emit('update:showModal', false);
    };

    const selectIcon = (icon: any) => {
      value1.value = icon;
    };

    onUpdated(() => {
      value1.value = props.value;
    });

    const filterIconData = computed(() => {
      const rest_list = [];
      props.icon_data.forEach(item => {
        const group = {
          group: item.group,
          icons: [],
        };
        group.icons = item.icons.filter(
          icon =>
            icon.name.toLowerCase().includes(searchValue.value.toLowerCase()) ||
            icon.value.toLowerCase().includes(searchValue.value.toLowerCase()),
        );
        if (group.icons.length > 0) {
          rest_list.push(group);
        }
      });
      return rest_list;
    });

    return {
      showModal,
      searchValue,
      handleOk,
      value1,
      filterIconData,
      selectIcon,
    };
  },
});
</script>

<style lang="less" scoped>
.icon-select-container {
  position: relative;
  height: 600px;
  display: flex;
  flex-direction: column;

  .search-bar {
    position: sticky;
    top: 0;
    z-index: 1;
    padding: 12px;
    background: #fff;
    border-bottom: 1px solid #f0f0f0;
  }

  .icon-content {
    flex: 1;
    overflow-y: auto;
    padding: 12px;
  }

  .icon-groups {
    .icon-group {
      margin-bottom: 4px;

      .group-title {
        font-size: 16px;
        font-weight: 500;
        margin-bottom: 2px;
        color: #1f1f1f;
      }

      .icon-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
        gap: 2px;

        .icon-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 2px 20px;
          border-radius: 4px;
          cursor: pointer;
          transition: all 0.3s;

          &:hover {
            border-color: #1890ff;
            background-color: #e6f7ff;
          }

          &.icon-selected {
            border-color: #1890ff;
            background-color: #1677ff;
            color: #fff;

            .icon-name {
              color: #fff;
            }
          }

          .anticon {
            font-size: 24px;
            margin-bottom: 8px;
          }

          .icon-name {
            font-size: 12px;
            color: #666;
            text-align: center;
            word-break: break-all;
          }
        }
      }
    }
  }
}
</style>
